type Props = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: Props) {
  const isCenter = align === "center";
  return (
    <div
      className={
        isCenter
          ? "mx-auto flex max-w-3xl flex-col items-center text-center"
          : "flex flex-col items-start"
      }
    >
      <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium tracking-wide text-primary-800">
        <span className="flex h-3.5 w-3.5 items-center justify-center">
          <i className="ri-git-commit-line"></i>
        </span>
        {eyebrow}
      </span>
      <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc && (
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
          {desc}
        </p>
      )}
    </div>
  );
}